import React from "react";
import { FiPower } from "react-icons/fi";
import { FaUser } from "react-icons/fa";
import { useGlobalContext } from "../../../hooks/context";

const PaymentHeader = () => {
  const { userLogout } = useGlobalContext();
  return (
    <div className="flex justify-between mt-10 sm:px-8">
      <div>
        {/* <h3 className="text-2xl font-medium md">LOGO</h3> */}
        <h3 className="text-2xl font-medium">Assalamu Alaikum,</h3>
        {/* <h3 className="text-xl font-medium">Mr. Name!</h3> */}
      </div>
      <div>
        <img className="h-20 mx-auto" src="/logo/pair-logo.png" alt="" />
        <div className="mt-5 flex items-center gap-x-5">
          <button onClick={userLogout}>
            <FiPower size={28} />
          </button>
          <div className="w-[1px] h-5 border-r-2 border-gray-500" />
          <span className="p-1.5  bg-gray-400 rounded-full">
            <FaUser size={20} />
          </span>
        </div>
      </div>
    </div>
  );
};

export default PaymentHeader;
